module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticStyle: {
      "-webkit-text-size-adjust": "100%",
      "-ms-text-size-adjust": "100%",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "font-size": "62.5%",
      "-webkit-tap-highlight-color": "transparent",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "#ffffff",
      "box-shadow": "none !important",
      "margin": "0",
      "padding": "0",
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticClass: "invoice-preview"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditable),
      expression: "!isEditable"
    }],
    staticStyle: {
      "margin": "0 auto",
      "width": "700px"
    },
    attrs: {
      "data-html2canvas-ignore": ""
    }
  }, [_c('ul', {
    staticClass: "nav navbar-toolbar navbar-right navbar-toolbar-right"
  }, [_c('li', {
    staticClass: "nav-item dropdown lang"
  }, [_c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [(_vm.lang != 'en') ? _c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLang('en')
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.lang != 'fr') ? _c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLang('fr')
      }
    }
  }, [_vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-toggle nav-link nav-link2",
    attrs: {
      "data-toggle": "dropdown",
      "href": "javascript:void(0)",
      "data-animation": "scale-up",
      "aria-expanded": "false",
      "role": "button"
    }
  }, [_c('span', {
    class: _vm.lang == 'en' ? 'flag-icon flag-icon-us' : 'flag-icon flag-icon-fr'
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content wide-content",
    staticStyle: {
      "text-align": "center",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "min-width": "0px",
      "min-height": "318px",
      "padding-bottom": "0px !important",
      "overflow": "visible",
      "position": "relative",
      "border-left-width": "1px",
      "border-left-color": "#dae3e9",
      "border-left-style": "solid",
      "border-bottom-width": "1px",
      "border-bottom-style": "solid",
      "border-bottom-color": "#dae3e9",
      "border-radius": "0",
      "-webkit-transition": "margin-left .3s ease",
      "-moz-transition": "margin-left .3s ease",
      "-o-transition": "margin-left .3s ease",
      "-ms-transition": "margin-left .3s ease",
      "transition": "margin-left .3s ease",
      "padding-top": "20px",
      "margin": "0 0 0px"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "margin-right": "auto",
      "margin-left": "auto",
      "padding-left": "15px",
      "padding-right": "15px",
      "max-width": "1170px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "invoice_preview invoice",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "font-size": "150%",
      "min-width": "700px",
      "max-width": "700px",
      "overflow": "visible",
      "margin": "auto auto 20px",
      "padding": "0.5cm 0px 0px",
      "border": "1px solid #ddd"
    }
  }, [_c('div', {
    staticClass: "vat",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }, [_c('div', {
    staticClass: "invoice_outline vf",
    staticStyle: {
      "background-color": "transparent !important",
      "background-position": "50% 13cm !important",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "box-shadow": "none !important",
      "-webkit-print-color-adjust": "exact",
      "font-family": "helvetica,&#39",
      "min-height": "25cm",
      "padding-top": "0",
      "background-repeat": "no-repeat",
      "margin": "0.25in 0.75cm"
    },
    attrs: {
      "id": "invoiceOutline"
    }
  }, [_c('table', {
    staticClass: "full_width",
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "max-width": "100%",
      "font-size": "0.6em",
      "page-break-after": "auto",
      "clear": "both",
      "empty-cells": "hide",
      "width": "99%",
      "text-align": "left",
      "vertical-align": "top",
      "page-break-inside": "auto",
      "margin": "0px auto",
      "border": "0"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('td', {
    staticClass: "vert_align_top  text_left",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "text-align": "left",
      "vertical-align": "top",
      "margin": "0",
      "padding": "5px 5px 5px 10px",
      "border": "0"
    },
    attrs: {
      "align": "left",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('p', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "orphans": "3",
      "widows": "3",
      "line-height": "1.4em",
      "margin": "0 0 0.5em"
    }
  }, [_c('strong', {
    staticClass: "big_text",
    staticStyle: {
      "font-weight": "bold",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.facture),
      expression: "!editable.facture"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('facture')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.facture ? _vm.invoice.facture : _vm.$t('booking.detail.invoices.title'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.facture),
      expression: "editable.facture"
    }]
  }, [_c('input', {
    ref: "facture",
    attrs: {
      "id": "facture"
    },
    domProps: {
      "value": (_vm.invoice.facture ? _vm.invoice.facture : _vm.$t('booking.detail.invoices.title'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('facture', $event)
      }
    }
  })])]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), (_vm.booking.checkout) ? _c('strong', {
    staticClass: "medium_text",
    staticStyle: {
      "font-weight": "bold",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "display": "block",
      "margin-top": "0px !important",
      "margin-bottom": "7px !important"
    }
  }, [_vm._v("\n                                                  N°\n                                                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.facture_number),
      expression: "!editable.facture_number"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('facture_number')
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.invoice.facture_number ? _vm.invoice.facture_number : _vm.booking.id) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.facture_number),
      expression: "editable.facture_number"
    }]
  }, [_c('input', {
    ref: "facture_number",
    attrs: {
      "id": "facture"
    },
    domProps: {
      "value": _vm.invoice.facture_number ? _vm.invoice.facture_number : _vm.booking.id
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('facture_number', $event)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("\n                                                  " + _vm._s(_vm.$t('booking.detail.invoices.creation_date')) + "\n                                                  "), _c('span', [_vm._v(_vm._s(_vm.booking.created_at))])])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('td', {
    staticClass: "vert_align_top text_right",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "right",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top",
      "width": "60%",
      "margin": "0",
      "padding": "5px",
      "border": "0"
    },
    attrs: {
      "id": "logo",
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [(_vm.rental.invoice_logo) ? _c('img', {
    staticStyle: {
      "height": "150px",
      "width": "222px",
      "object-fit": "contain",
      "margin-bottom": "30px !important",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "vertical-align": "middle",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid",
      "max-width": "100% !important",
      "border": "0"
    },
    attrs: {
      "src": _vm.api_url + '/images/invoice-logo/' + _vm.rental.invoice_logo,
      "alt": "logo"
    }
  }) : _vm._e()])])])]), _vm._v(" "), _c('table', {
    staticClass: "seller_buyer full_width",
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "max-width": "100%",
      "font-size": "0.6em",
      "page-break-after": "auto",
      "clear": "both",
      "empty-cells": "hide",
      "width": "99%",
      "text-align": "left",
      "vertical-align": "top",
      "page-break-inside": "auto",
      "margin": "0px auto",
      "border": "0"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('td', {
    staticClass: "vert_align_top",
    staticStyle: {
      "width": "70%",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "text-align": "left",
      "vertical-align": "top",
      "margin": "0",
      "padding": "5px",
      "border": "0"
    },
    attrs: {
      "align": "left",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-weight": "bold",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.vendeur_label),
      expression: "!editable.vendeur_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('vendeur_label')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.vendeur_label ? _vm.invoice.vendeur_label : _vm.$t('booking.detail.invoices.seller'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.vendeur_label),
      expression: "editable.vendeur_label"
    }]
  }, [_c('input', {
    ref: "vendeur_label",
    domProps: {
      "value": (_vm.invoice.vendeur_label ? _vm.invoice.vendeur_label : _vm.$t('booking.detail.invoices.seller'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('vendeur_label', $event)
      }
    }
  })])]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.invoice_name),
      expression: "!editable.invoice_name"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('invoice_name')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.invoice_name ? _vm.invoice.invoice_name : (_vm.rental.invoice_name ? _vm.rental.invoice_name : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.invoice_name),
      expression: "editable.invoice_name"
    }]
  }, [_c('input', {
    ref: "invoice_name",
    attrs: {
      "id": "invoice_name"
    },
    domProps: {
      "value": (_vm.invoice.invoice_name ? _vm.invoice.invoice_name : _vm.rental.invoice_name)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('invoice_name', $event)
      }
    }
  })]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.invoice_address),
      expression: "!editable.invoice_address"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('invoice_address')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.invoice_address ? _vm.invoice.invoice_address : (_vm.rental.invoice_address ? _vm.rental.invoice_address : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.invoice_address),
      expression: "editable.invoice_address"
    }]
  }, [_c('input', {
    ref: "invoice_address",
    attrs: {
      "id": "invoice_address"
    },
    domProps: {
      "value": (_vm.invoice.invoice_address ? _vm.invoice.invoice_address : _vm.rental.invoice_address)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('invoice_address', $event)
      }
    }
  })]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.invoice_zip_code),
      expression: "!editable.invoice_zip_code"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('invoice_zip_code')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.invoice_zip_code ? _vm.invoice.invoice_zip_code : (_vm.rental.invoice_zip_code ? _vm.rental.invoice_zip_code : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.invoice_zip_code),
      expression: "editable.invoice_zip_code"
    }]
  }, [_c('input', {
    ref: "invoice_zip_code",
    attrs: {
      "id": "invoice_zip_code"
    },
    domProps: {
      "value": (_vm.invoice.invoice_zip_code ? _vm.invoice.invoice_zip_code : _vm.rental.invoice_zip_code)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('invoice_zip_code', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.invoice_city),
      expression: "!editable.invoice_city"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('invoice_city')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.invoice_city ? _vm.invoice.invoice_city : (_vm.rental.invoice_city ? _vm.rental.invoice_city : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.invoice_city),
      expression: "editable.invoice_city"
    }]
  }, [_c('input', {
    ref: "invoice_city",
    attrs: {
      "id": "invoice_city"
    },
    domProps: {
      "value": (_vm.invoice.invoice_city ? _vm.invoice.invoice_city : _vm.rental.invoice_city)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('invoice_city', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.invoice_country),
      expression: "!editable.invoice_country"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('invoice_country')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.invoice_country ? _vm.invoice.invoice_country : (_vm.rental.invoice_country ? _vm.rental.invoice_country : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.invoice_country),
      expression: "editable.invoice_country"
    }]
  }, [_c('input', {
    ref: "invoice_country",
    attrs: {
      "id": "invoice_country"
    },
    domProps: {
      "value": (_vm.invoice.invoice_country ? _vm.invoice.invoice_country : _vm.rental.invoice_country)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('invoice_country', $event)
      }
    }
  })]), _vm._v(" "), _c('span', [_c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.owner_first_name),
      expression: "!editable.owner_first_name"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('owner_first_name')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.owner_first_name ? _vm.invoice.owner_first_name : _vm.rental.owner_first_name)) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.owner_first_name),
      expression: "editable.owner_first_name"
    }]
  }, [_c('input', {
    ref: "invoice_country",
    attrs: {
      "id": "owner_first_name"
    },
    domProps: {
      "value": (_vm.invoice.owner_first_name ? _vm.invoice.owner_first_name : _vm.rental.owner_first_name)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('owner_first_name', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.owner_last_name),
      expression: "!editable.owner_last_name"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('owner_last_name')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.owner_last_name ? _vm.invoice.owner_last_name : _vm.rental.owner_last_name)) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.owner_last_name),
      expression: "editable.owner_last_name"
    }]
  }, [_c('input', {
    ref: "invoice_country",
    attrs: {
      "id": "owner_last_name"
    },
    domProps: {
      "value": (_vm.invoice.owner_last_name ? _vm.invoice.owner_last_name : _vm.rental.owner_last_name)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('owner_last_name', $event)
      }
    }
  })])]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.siret),
      expression: "!editable.siret"
    }],
    attrs: {
      "for": "siret"
    },
    on: {
      "click": function($event) {
        _vm.enableEditing('siret')
      }
    }
  }, [_vm._v("\n                                                " + _vm._s((_vm.invoice.siret ? _vm.invoice.siret : "-")) + "\n                                            ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.siret),
      expression: "editable.siret"
    }]
  }, [_c('input', {
    ref: "siret",
    attrs: {
      "id": "siret"
    },
    domProps: {
      "value": (_vm.invoice.siret ? _vm.invoice.siret : 'SIRET')
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('siret', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.invoice_business_number),
      expression: "!editable.invoice_business_number"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('invoice_business_number')
      }
    }
  }, [_vm._v("\n                                              " + _vm._s((_vm.invoice.invoice_business_number ? _vm.invoice.invoice_business_number : (_vm.rental.invoice_business_number ? _vm.rental.invoice_business_number : ''))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.invoice_business_number),
      expression: "editable.invoice_business_number"
    }]
  }, [_c('input', {
    ref: "invoice_business_number",
    attrs: {
      "id": "invoice_business_number"
    },
    domProps: {
      "value": (_vm.invoice.invoice_business_number ? _vm.invoice.invoice_business_number : _vm.rental.invoice_business_number)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('invoice_business_number', $event)
      }
    }
  })]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), (_vm.booking.checking && _vm.booking.checkout) ? _c('span', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.rental_name),
      expression: "!editable.rental_name"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('rental_name')
      }
    }
  }, [_vm._v(" " + _vm._s((_vm.invoice.rental_name ? _vm.invoice.rental_name : (_vm.rental.name ? _vm.rental.name : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.rental_name),
      expression: "editable.rental_name"
    }]
  }, [_c('input', {
    ref: "rental_name",
    attrs: {
      "id": "rental_name"
    },
    domProps: {
      "value": (_vm.invoice.rental_name ? _vm.invoice.rental_name : _vm.rental.name)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('rental_name', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.checking_checkout),
      expression: "!editable.checking_checkout"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('checking_checkout')
      }
    }
  }, [_vm._v("\n                                              " + _vm._s((_vm.invoice.checking_checkout ? _vm.invoice.checking_checkout : ((_vm.changeDateFormat(_vm.booking.checking, 'dd DD MMMM YYYY')) + ' - ' + (_vm.changeDateFormat(_vm.booking.checkout, 'dd DD MMMM YYYY'))))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.checking_checkout),
      expression: "editable.checking_checkout"
    }]
  }, [_c('input', {
    ref: "checking_checkout",
    attrs: {
      "id": "checking_checkout"
    },
    domProps: {
      "value": (_vm.invoice.checking_checkout ? _vm.invoice.checking_checkout : ((_vm.changeDateFormat(_vm.booking.checking, 'dd DD MMMM YYYY')) + ' - ' + (_vm.changeDateFormat(_vm.booking.checkout, 'dd DD MMMM YYYY'))))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('checking_checkout', $event)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('span', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.rental_address),
      expression: "!editable.rental_address"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('rental_address')
      }
    }
  }, [_vm._v(" " + _vm._s((_vm.invoice.rental_address ? _vm.invoice.rental_address : (_vm.rental.address ? _vm.rental.address : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.rental_address),
      expression: "editable.rental_address"
    }]
  }, [_c('input', {
    ref: "rental_address",
    attrs: {
      "id": "rental_address"
    },
    domProps: {
      "value": _vm.invoice.rental_address ? _vm.invoice.rental_address : _vm.rental.address
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('rental_address', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.rental_zip_code),
      expression: "!editable.rental_zip_code"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('rental_zip_code')
      }
    }
  }, [_vm._v("\n                                              " + _vm._s((_vm.invoice.rental_zip_code ? _vm.invoice.rental_zip_code : _vm.rental.zip_code)) + "\n                                            ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.rental_zip_code),
      expression: "editable.rental_zip_code"
    }]
  }, [_c('input', {
    ref: "rental_zip_code",
    attrs: {
      "id": "rental_zip_code"
    },
    domProps: {
      "value": (_vm.invoice.rental_zip_code ? _vm.invoice.rental_zip_code : _vm.rental.zip_code)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('rental_zip_code', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.rental_city),
      expression: "!editable.rental_city"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('rental_city')
      }
    }
  }, [_vm._v("\n                                              " + _vm._s((_vm.invoice.rental_city ? _vm.invoice.rental_city : _vm.rental.city)) + "\n                                            ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.rental_city),
      expression: "editable.rental_city"
    }]
  }, [_c('input', {
    ref: "rental_city",
    attrs: {
      "id": "rental_city"
    },
    domProps: {
      "value": (_vm.invoice.rental_city ? _vm.invoice.rental_city : _vm.rental.city)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('rental_city', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.rental_country),
      expression: "!editable.rental_country"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('rental_country')
      }
    }
  }, [_vm._v("\n                                              " + _vm._s((_vm.invoice.rental_country ? _vm.invoice.rental_country : (_vm.rental.country ? _vm.rental.country.name : ''))) + "\n                                            ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.rental_country),
      expression: "editable.rental_country"
    }]
  }, [_c('input', {
    ref: "rental_country",
    attrs: {
      "id": "rental_country"
    },
    domProps: {
      "value": (_vm.invoice.rental_country ? _vm.invoice.rental_country : (_vm.rental.country ? _vm.rental.country.name : ''))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('rental_country', $event)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.booking_nbr_adults_label),
      expression: "!editable.booking_nbr_adults_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('booking_nbr_adults_label')
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.invoice.booking_nbr_adults_label ? _vm.invoice.booking_nbr_adults_label : _vm.$t('booking.detail.invoices.nbr_adults')) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.booking_nbr_adults_label),
      expression: "editable.booking_nbr_adults_label"
    }]
  }, [_c('input', {
    ref: "booking_nbr_adults_label",
    domProps: {
      "value": _vm.invoice.booking_nbr_adults_label ? _vm.invoice.booking_nbr_adults_label : _vm.$t('booking.detail.invoices.nbr_adults')
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('booking_nbr_adults_label', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.booking_nbr_adults),
      expression: "!editable.booking_nbr_adults"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('booking_nbr_adults')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.booking_nbr_adults ? _vm.invoice.booking_nbr_adults : _vm.booking.nbr_adults)) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.booking_nbr_adults),
      expression: "editable.booking_nbr_adults"
    }]
  }, [_c('input', {
    ref: "booking_nbr_adults",
    attrs: {
      "id": "booking_nbr_adults"
    },
    domProps: {
      "value": (_vm.invoice.booking_nbr_adults ? _vm.invoice.booking_nbr_adults : _vm.booking.nbr_adults)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('booking_nbr_adults', $event)
      }
    }
  })]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.booking_nbr_children_label),
      expression: "!editable.booking_nbr_children_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('booking_nbr_children_label')
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.invoice.booking_nbr_children_label ? _vm.invoice.booking_nbr_children_label : _vm.$t('booking.detail.invoices.nbr_children')) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.booking_nbr_children_label),
      expression: "editable.booking_nbr_children_label"
    }]
  }, [_c('input', {
    ref: "booking_nbr_children_label",
    domProps: {
      "value": _vm.invoice.booking_nbr_children_label ? _vm.invoice.booking_nbr_children_label : _vm.$t('booking.detail.invoices.nbr_children')
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('booking_nbr_children_label', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.booking_nbr_children),
      expression: "!editable.booking_nbr_children"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('booking_nbr_children')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.booking_nbr_children ? _vm.invoice.booking_nbr_children : _vm.booking.nbr_children)) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.booking_nbr_children),
      expression: "editable.booking_nbr_children"
    }]
  }, [_c('input', {
    ref: "booking_nbr_children",
    attrs: {
      "id": "booking_nbr_children"
    },
    domProps: {
      "value": (_vm.invoice.booking_nbr_children ? _vm.invoice.booking_nbr_children : _vm.booking.nbr_children)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('booking_nbr_children', $event)
      }
    }
  })]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "vert_align_top",
    staticStyle: {
      "width": "30%",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "text-align": "left",
      "vertical-align": "top",
      "margin": "0",
      "padding": "5px",
      "border": "0"
    },
    attrs: {
      "align": "left",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-weight": "bold",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.acheteur_label),
      expression: "!editable.acheteur_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('acheteur_label')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.acheteur_label ? _vm.invoice.acheteur_label : _vm.$t('booking.detail.invoices.customer'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.acheteur_label),
      expression: "editable.acheteur_label"
    }]
  }, [_c('input', {
    ref: "acheteur_label",
    domProps: {
      "value": (_vm.invoice.acheteur_label ? _vm.invoice.acheteur_label : _vm.$t('booking.detail.invoices.customer'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('acheteur_label', $event)
      }
    }
  })])]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    },
    attrs: {
      "id": "buyer"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.guest_first_name),
      expression: "!editable.guest_first_name"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('guest_first_name')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.guest_first_name ? _vm.invoice.guest_first_name : (_vm.guest.first_name ? _vm.guest.first_name : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.guest_first_name),
      expression: "editable.guest_first_name"
    }]
  }, [_c('input', {
    ref: "guest_first_name",
    attrs: {
      "id": "guest_first_name"
    },
    domProps: {
      "value": (_vm.invoice.guest_first_name ? _vm.invoice.guest_first_name : _vm.guest.first_name)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('guest_first_name', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.guest_last_name),
      expression: "!editable.guest_last_name"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('guest_last_name')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.guest_last_name ? _vm.invoice.guest_last_name : (_vm.guest.last_name ? _vm.guest.last_name : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.guest_last_name),
      expression: "editable.guest_last_name"
    }]
  }, [_c('input', {
    ref: "guest_last_name",
    attrs: {
      "id": "guest_last_name"
    },
    domProps: {
      "value": (_vm.invoice.guest_last_name ? _vm.invoice.guest_last_name : _vm.guest.last_name)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('guest_last_name', $event)
      }
    }
  })]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.guest_address),
      expression: "!editable.guest_address"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('guest_address')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.guest_address ? _vm.invoice.guest_address : (_vm.guest.address ? _vm.guest.address : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.guest_address),
      expression: "editable.guest_address"
    }]
  }, [_c('input', {
    ref: "guest_address",
    attrs: {
      "id": "guest_address"
    },
    domProps: {
      "value": (_vm.invoice.guest_address ? _vm.invoice.guest_address : _vm.guest.address)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('guest_address', $event)
      }
    }
  })]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.guest_city),
      expression: "!editable.guest_city"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('guest_city')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.guest_city ? _vm.invoice.guest_city : (_vm.guest.city ? _vm.guest.city : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.guest_city),
      expression: "editable.guest_city"
    }]
  }, [_c('input', {
    ref: "guest_city",
    attrs: {
      "id": "guest_city"
    },
    domProps: {
      "value": (_vm.invoice.guest_city ? _vm.invoice.guest_city : _vm.guest.city)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('guest_city', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.guest_country),
      expression: "!editable.guest_country"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('guest_country')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.guest_country ? _vm.invoice.guest_country : (_vm.guest.country ? _vm.guest.country : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.guest_country),
      expression: "editable.guest_country"
    }]
  }, [_c('input', {
    ref: "guest_country",
    attrs: {
      "id": "guest_country"
    },
    domProps: {
      "value": (_vm.invoice.guest_country ? _vm.invoice.guest_country : _vm.guest.country)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('guest_country', $event)
      }
    }
  })]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.guest_zip_code),
      expression: "!editable.guest_zip_code"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('guest_zip_code')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.guest_zip_code ? _vm.invoice.guest_zip_code : (_vm.guest.zip_code ? _vm.guest.zip_code : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.guest_zip_code),
      expression: "editable.guest_zip_code"
    }]
  }, [_c('input', {
    ref: "guest_zip_code",
    attrs: {
      "id": "guest_zip_code"
    },
    domProps: {
      "value": (_vm.invoice.guest_zip_code ? _vm.invoice.guest_zip_code : _vm.guest.zip_code)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('guest_zip_code', $event)
      }
    }
  })]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  })])])])])]), _vm._v(" "), _c('table', {
    staticClass: "main_inv_table full_width",
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "max-width": "100%",
      "font-size": "0.6em",
      "page-break-after": "auto",
      "clear": "both",
      "empty-cells": "hide",
      "width": "99%",
      "text-align": "left",
      "vertical-align": "top",
      "page-break-inside": "auto",
      "margin": "5px auto 0px",
      "border": "0"
    },
    attrs: {
      "id": "pos_table",
      "bgcolor": "transparent !important"
    }
  }, [_c('thead', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "display": "table-header-group !important"
    }
  }, [_c('tr', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('th', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "right",
      "width": "4%",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "font-weight": "bold",
      "white-space": "nowrap",
      "margin": "0",
      "padding": "5px",
      "border": "1px solid #bbbbbb"
    },
    attrs: {
      "id": "nr_col",
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_vm._v("N°")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "left",
      "width": "50%",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "font-weight": "bold",
      "margin": "0",
      "padding": "5px 5px 5px 10px",
      "border": "1px solid #bbbbbb"
    },
    attrs: {
      "id": "name_col",
      "align": "left",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.designation')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "right",
      "width": "10%",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "font-weight": "bold",
      "margin": "0",
      "padding": "5px",
      "border": "1px solid #bbbbbb"
    },
    attrs: {
      "id": "total_price_net_col",
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.total_ht')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "right",
      "width": "10%",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "font-weight": "bold",
      "white-space": "nowrap",
      "margin": "0",
      "padding": "5px",
      "border": "1px solid #bbbbbb"
    },
    attrs: {
      "id": "tax_col",
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.vat')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "right",
      "width": "16%",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "font-weight": "bold",
      "margin": "0",
      "padding": "5px",
      "border": "1px solid #bbbbbb"
    },
    attrs: {
      "id": "tax_value_col",
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.vat_amount')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "right",
      "width": "10%",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "font-weight": "bold",
      "white-space": "nowrap",
      "margin": "0",
      "padding": "5px",
      "border": "1px solid #bbbbbb"
    },
    attrs: {
      "id": "total_price_gross_col",
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.total_ttc')))])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }, _vm._l((_vm.invoices), function(inv, index) {
    return (!inv.imported ? inv.captured === 1 : true) ? _c('tr', {
      staticStyle: {
        "-webkit-box-sizing": "border-box",
        "-moz-box-sizing": "border-box",
        "box-sizing": "border-box",
        "text-shadow": "none !important",
        "color": "#000 !important",
        "background-color": "transparent !important",
        "box-shadow": "none !important",
        "page-break-inside": "avoid !important",
        "page-break-after": "auto",
        "vertical-align": "top"
      },
      attrs: {
        "bgcolor": "transparent !important"
      }
    }, [_c('td', {
      staticClass: "nr_col",
      staticStyle: {
        "-webkit-box-sizing": "border-box",
        "-moz-box-sizing": "border-box",
        "box-sizing": "border-box",
        "text-shadow": "none !important",
        "color": "#000 !important",
        "background-color": "transparent !important",
        "box-shadow": "none !important",
        "page-break-inside": "avoid !important",
        "page-break-after": "auto",
        "text-align": "right",
        "vertical-align": "top",
        "border-collapse": "collapse",
        "margin": "0",
        "padding": "5px",
        "border": "1px solid #d8d7d7"
      },
      attrs: {
        "align": "right",
        "bgcolor": "transparent !important",
        "valign": "top"
      }
    }, [_vm._v("\n                                              " + _vm._s(index + 1) + "\n                                          ")]), _vm._v(" "), _c('td', {
      staticClass: "name_col",
      staticStyle: {
        "-webkit-box-sizing": "border-box",
        "-moz-box-sizing": "border-box",
        "box-sizing": "border-box",
        "text-shadow": "none !important",
        "color": "#000 !important",
        "background-color": "transparent !important",
        "box-shadow": "none !important",
        "page-break-inside": "avoid !important",
        "page-break-after": "auto",
        "text-align": "left",
        "vertical-align": "top",
        "border-collapse": "collapse",
        "margin": "0",
        "padding": "5px",
        "border": "1px solid #d8d7d7"
      },
      attrs: {
        "align": "left",
        "bgcolor": "transparent !important",
        "valign": "top"
      }
    }, [(inv.type == 'other') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_desc_other' + inv.id]),
        expression: "!editable['edit_desc_other' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('other_payment_description', inv.id, '_desc_other')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_desc_other' + inv.id]),
        expression: "editable['edit_desc_other' + inv.id]"
      }]
    }, [_c('input', {
      ref: "other_payment_description",
      refInFor: true,
      attrs: {
        "type": "text",
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('other_payment_description', $event, inv.id, '_desc_other')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'service charge') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_desc_service_charge' + inv.id]),
        expression: "!editable['edit_desc_service_charge' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('service_charge_payment_description', inv.id, '_desc_service_charge')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_desc_service_charge' + inv.id]),
        expression: "editable['edit_desc_service_charge' + inv.id]"
      }]
    }, [_c('input', {
      ref: "service_charge_payment_description",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('service_charge_payment_description', $event, inv.id, '_desc_service_charge')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'cleaning') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_desc_cleaning' + inv.id]),
        expression: "!editable['edit_desc_cleaning' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('cleaning_payment_description', inv.id, '_desc_cleaning')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_desc_cleaning' + inv.id]),
        expression: "editable['edit_desc_cleaning' + inv.id]"
      }]
    }, [_c('input', {
      ref: "cleaning_payment_description",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('cleaning_payment_description', $event, inv.id, '_desc_cleaning')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'taxes') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_desc_taxes' + inv.id]),
        expression: "!editable['edit_desc_taxes' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('taxes_payment_description', inv.id, '_desc_taxes')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_desc_taxes' + inv.id]),
        expression: "editable['edit_desc_taxes' + inv.id]"
      }]
    }, [_c('input', {
      ref: "taxes_payment_description",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('taxes_payment_description', $event, inv.id, '_desc_taxes')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'hostFee') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_desc_host_fee' + inv.id]),
        expression: "!editable['edit_desc_host_fee' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('host_fee_payment_description', inv.id, '_desc_host_fee')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_desc_host_fee' + inv.id]),
        expression: "editable['edit_desc_host_fee' + inv.id]"
      }]
    }, [_c('input', {
      ref: "host_fee_payment_description",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('host_fee_payment_description', $event, inv.id, '_desc_host_fee')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'promotion') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_desc_promotion' + inv.id]),
        expression: "!editable['edit_desc_promotion' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('promotion_payment_description', inv.id, '_desc_promotion')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_desc_promotion' + inv.id]),
        expression: "editable['edit_desc_promotion' + inv.id]"
      }]
    }, [_c('input', {
      ref: "promotion_payment_description",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('promotion_payment_description', $event, inv.id, '_desc_promotion')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'nights') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_desc_nights' + inv.id]),
        expression: "!editable['edit_desc_nights' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('nights_payment_description', inv.id, '_desc_nights')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_desc_nights' + inv.id]),
        expression: "editable['edit_desc_nights' + inv.id]"
      }]
    }, [_c('input', {
      ref: "nights_payment_description",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('nights_payment_description', $event, inv.id, '_desc_nights')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'schedule') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_schedule' + inv.id]),
        expression: "!editable['edit_schedule' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('schedule_payment_description', inv.id, '_desc_schedule')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_schedule' + inv.id]),
        expression: "editable['edit_schedule' + inv.id]"
      }]
    }, [_c('input', {
      ref: "schedule_payment_description",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('schedule_payment_description', $event, inv.id, '_desc_schedule')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'auto') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_auto' + inv.id]),
        expression: "!editable['edit_auto' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('auto_payment_description', inv.id, '_desc_auto')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_auto' + inv.id]),
        expression: "editable['edit_auto' + inv.id]"
      }]
    }, [_c('input', {
      ref: "auto_payment_description",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].description ? _vm.obj[0].description : (inv.description ? inv.description : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('auto_payment_description', $event, inv.id, '_desc_auto')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "item_description",
      staticStyle: {
        "-webkit-box-sizing": "border-box",
        "-moz-box-sizing": "border-box",
        "box-sizing": "border-box",
        "text-shadow": "none !important",
        "color": "#000 !important",
        "background-color": "transparent !important",
        "box-shadow": "none !important",
        "display": "block"
      },
      attrs: {
        "id": "product_description"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text_right no_wrap number total_price_net_col",
      staticStyle: {
        "-webkit-box-sizing": "border-box",
        "-moz-box-sizing": "border-box",
        "box-sizing": "border-box",
        "text-shadow": "none !important",
        "color": "#000 !important",
        "background-color": "transparent !important",
        "box-shadow": "none !important",
        "white-space": "nowrap !important",
        "text-align": "right",
        "page-break-inside": "avoid !important",
        "page-break-after": "auto",
        "vertical-align": "top",
        "border-collapse": "collapse",
        "margin": "0",
        "padding": "5px",
        "border": "1px solid #d8d7d7"
      },
      attrs: {
        "align": "right",
        "bgcolor": "transparent !important",
        "valign": "top"
      }
    }, [(inv.type == 'other') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_total_other' + inv.id]),
        expression: "!editable['edit_total_other' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('other_payment_total_nt_col', inv.id, '_total_other')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_total_other' + inv.id]),
        expression: "editable['edit_total_other' + inv.id]"
      }]
    }, [_c('input', {
      ref: "other_payment_total_nt_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('other_payment_total_nt_col', $event, inv.id, '_total_other')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'service charge') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_total_service_charge' + inv.id]),
        expression: "!editable['edit_total_service_charge' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('service_charge_payment_total_nt_col', inv.id, '_total_service_charge')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_total_service_charge' + inv.id]),
        expression: "editable['edit_total_service_charge' + inv.id]"
      }]
    }, [_c('input', {
      ref: "service_charge_payment_total_nt_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('service_charge_payment_total_nt_col', $event, inv.id, '_total_service_charge')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'cleaning') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_total_cleaning' + inv.id]),
        expression: "!editable['edit_total_cleaning' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('cleaning_payment_total_nt_col', inv.id, '_total_cleaning')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_total_cleaning' + inv.id]),
        expression: "editable['edit_total_cleaning' + inv.id]"
      }]
    }, [_c('input', {
      ref: "cleaning_payment_total_nt_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('cleaning_payment_total_nt_col', $event, inv.id, '_total_cleaning')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'taxes') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_total_taxes' + inv.id]),
        expression: "!editable['edit_total_taxes' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('taxes_payment_total_nt_col', inv.id, '_total_taxes')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_total_taxes' + inv.id]),
        expression: "editable['edit_total_taxes' + inv.id]"
      }]
    }, [_c('input', {
      ref: "taxes_payment_total_nt_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('taxes_payment_total_nt_col', $event, inv.id, '_total_taxes')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'hostFee') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_total_host_fee' + inv.id]),
        expression: "!editable['edit_total_host_fee' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('host_fee_payment_total_nt_col', inv.id, '_total_host_fee')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_total_host_fee' + inv.id]),
        expression: "editable['edit_total_host_fee' + inv.id]"
      }]
    }, [_c('input', {
      ref: "host_fee_payment_total_nt_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('host_fee_payment_total_nt_col', $event, inv.id, '_total_host_fee')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'promotion') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_total_promotion' + inv.id]),
        expression: "!editable['edit_total_promotion' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('promotion_payment_total_nt_col', inv.id, '_total_promotion')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_total_promotion' + inv.id]),
        expression: "editable['edit_total_promotion' + inv.id]"
      }]
    }, [_c('input', {
      ref: "promotion_payment_total_nt_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('promotion_payment_total_nt_col', $event, inv.id, '_total_promotion')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'nights') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_total_nights' + inv.id]),
        expression: "!editable['edit_total_nights' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('nights_payment_total_nt_col', inv.id, '_total_nights')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_total_nights' + inv.id]),
        expression: "editable['edit_total_nights' + inv.id]"
      }]
    }, [_c('input', {
      ref: "nights_payment_total_nt_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('nights_payment_total_nt_col', $event, inv.id, '_total_nights')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'schedule') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_total_schedule' + inv.id]),
        expression: "!editable['edit_total_schedule' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('schedule_payment_total_nt_col', inv.id, '_total_schedule')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_total_schedule' + inv.id]),
        expression: "editable['edit_total_schedule' + inv.id]"
      }]
    }, [_c('input', {
      ref: "schedule_payment_total_nt_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('schedule_payment_total_nt_col', $event, inv.id, '_total_schedule')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'auto') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_total_auto' + inv.id]),
        expression: "!editable['edit_total_auto' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('auto_payment_total_nt_col', inv.id, '_total_auto')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_total_auto' + inv.id]),
        expression: "editable['edit_total_auto' + inv.id]"
      }]
    }, [_c('input', {
      ref: "auto_payment_total_nt_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].total ? _vm.obj[0].total : (inv.originalAmount ? inv.originalAmount : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('auto_payment_total_nt_col', $event, inv.id, '_total_auto')
        }
      }
    })])]) : _vm._e(), _vm._v("\n                                            " + _vm._s(_vm.rental.currency) + "\n                                          ")]), _vm._v(" "), _c('td', {
      staticClass: "text_right no_wrap number tax_col",
      staticStyle: {
        "-webkit-box-sizing": "border-box",
        "-moz-box-sizing": "border-box",
        "box-sizing": "border-box",
        "text-shadow": "none !important",
        "color": "#000 !important",
        "background-color": "transparent !important",
        "box-shadow": "none !important",
        "white-space": "nowrap !important",
        "text-align": "right",
        "page-break-inside": "avoid !important",
        "page-break-after": "auto",
        "vertical-align": "top",
        "border-collapse": "collapse",
        "margin": "0",
        "padding": "5px",
        "border": "1px solid #d8d7d7"
      },
      attrs: {
        "align": "right",
        "bgcolor": "transparent !important",
        "valign": "top"
      }
    }, [(inv.type == 'other') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_other' + inv.id]),
        expression: "!editable['edit_tax_other' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('other_payment_tax_col', inv.id, '_tax_other')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_other' + inv.id]),
        expression: "editable['edit_tax_other' + inv.id]"
      }]
    }, [_c('input', {
      ref: "other_payment_tax_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('other_payment_tax_col', $event, inv.id, '_tax_other')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'service charge') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_service_charge' + inv.id]),
        expression: "!editable['edit_tax_service_charge' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('service_charge_payment_tax_col', inv.id, '_tax_service_charge')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_service_charge' + inv.id]),
        expression: "editable['edit_tax_service_charge' + inv.id]"
      }]
    }, [_c('input', {
      ref: "service_charge_payment_tax_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('service_charge_payment_tax_col', $event, inv.id, '_tax_service_charge')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'cleaning') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_cleaning' + inv.id]),
        expression: "!editable['edit_tax_cleaning' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('cleaning_payment_tax_col', inv.id, '_tax_cleaning')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_cleaning' + inv.id]),
        expression: "editable['edit_tax_cleaning' + inv.id]"
      }]
    }, [_c('input', {
      ref: "cleaning_payment_tax_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('cleaning_payment_tax_col', $event, inv.id, '_tax_cleaning')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'taxes') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_taxes' + inv.id]),
        expression: "!editable['edit_tax_taxes' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('taxes_payment_tax_col', inv.id, '_tax_taxes')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_taxes' + inv.id]),
        expression: "editable['edit_tax_taxes' + inv.id]"
      }]
    }, [_c('input', {
      ref: "taxes_payment_tax_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('taxes_payment_tax_col', $event, inv.id, '_tax_taxes')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'hostFee') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_host_fee' + inv.id]),
        expression: "!editable['edit_tax_host_fee' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('host_fee_payment_tax_col', inv.id, '_tax_host_fee')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_host_fee' + inv.id]),
        expression: "editable['edit_tax_host_fee' + inv.id]"
      }]
    }, [_c('input', {
      ref: "host_fee_payment_tax_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('host_fee_payment_tax_col', $event, inv.id, '_tax_host_fee')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'promotion') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_promotion' + inv.id]),
        expression: "!editable['edit_tax_promotion' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('promotion_payment_tax_col', inv.id, '_tax_promotion')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_promotion' + inv.id]),
        expression: "editable['edit_tax_promotion' + inv.id]"
      }]
    }, [_c('input', {
      ref: "promotion_payment_tax_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('promotion_payment_tax_col', $event, inv.id, '_tax_promotion')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'nights') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_nights' + inv.id]),
        expression: "!editable['edit_tax_nights' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('nights_payment_tax_col', inv.id, '_tax_nights')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_nights' + inv.id]),
        expression: "editable['edit_tax_nights' + inv.id]"
      }]
    }, [_c('input', {
      ref: "nights_payment_tax_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('nights_payment_tax_col', $event, inv.id, '_tax_nights')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type === 'schedule') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_schedule' + inv.id]),
        expression: "!editable['edit_tax_schedule' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('schedule_payment_tax_col', inv.id, '_tax_schedule')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_schedule' + inv.id]),
        expression: "editable['edit_tax_schedule' + inv.id]"
      }]
    }, [_c('input', {
      ref: "schedule_payment_tax_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('schedule_payment_tax_col', $event, inv.id, '_tax_schedule')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type === 'auto') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_auto' + inv.id]),
        expression: "!editable['edit_tax_auto' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('auto_payment_tax_col', inv.id, '_tax_auto')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_auto' + inv.id]),
        expression: "editable['edit_tax_auto' + inv.id]"
      }]
    }, [_c('input', {
      ref: "auto_payment_tax_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax ? _vm.obj[0].tax : (inv.vat ? inv.vat : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('auto_payment_tax_col', $event, inv.id, '_tax_auto')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (!['other', 'service charge', 'cleaning', 'taxes', 'nights', 'schedule', 'auto', 'hostFee', 'promotion'].includes(inv.type)) ? _c('span', [_vm._v("\n                                              0\n                                            ")]) : _vm._e(), _vm._v("\n                                            %\n                                          ")]), _vm._v(" "), _c('td', {
      staticClass: "text_right number no_wrap tax_value_col",
      staticStyle: {
        "-webkit-box-sizing": "border-box",
        "-moz-box-sizing": "border-box",
        "box-sizing": "border-box",
        "text-shadow": "none !important",
        "color": "#000 !important",
        "background-color": "transparent !important",
        "box-shadow": "none !important",
        "white-space": "nowrap !important",
        "text-align": "right",
        "page-break-inside": "avoid !important",
        "page-break-after": "auto",
        "vertical-align": "top",
        "border-collapse": "collapse",
        "margin": "0",
        "padding": "5px",
        "border": "1px solid #d8d7d7"
      },
      attrs: {
        "align": "right",
        "bgcolor": "transparent !important",
        "valign": "top"
      }
    }, [(inv.type == 'other') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_value_other' + inv.id]),
        expression: "!editable['edit_tax_value_other' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('other_payment_tax_value_col', inv.id, '_tax_value_other')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_value_other' + inv.id]),
        expression: "editable['edit_tax_value_other' + inv.id]"
      }]
    }, [_c('input', {
      ref: "other_payment_tax_value_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('other_payment_tax_value_col', $event, inv.id, '_tax_value_other')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'service charge') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_value_service_charge' + inv.id]),
        expression: "!editable['edit_tax_value_service_charge' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('service_charge_payment_tax_value_col', inv.id, '_tax_value_service_charge')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_value_service_charge' + inv.id]),
        expression: "editable['edit_tax_value_service_charge' + inv.id]"
      }]
    }, [_c('input', {
      ref: "service_charge_payment_tax_value_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('service_charge_payment_tax_value_col', $event, inv.id, '_tax_value_service_charge')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'cleaning') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_value_cleaning' + inv.id]),
        expression: "!editable['edit_tax_value_cleaning' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('cleaning_payment_tax_value_col', inv.id, '_tax_value_cleaning')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_value_cleaning' + inv.id]),
        expression: "editable['edit_tax_value_cleaning' + inv.id]"
      }]
    }, [_c('input', {
      ref: "cleaning_payment_tax_value_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('cleaning_payment_tax_value_col', $event, inv.id, '_tax_value_cleaning')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'taxes') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_value_taxes' + inv.id]),
        expression: "!editable['edit_tax_value_taxes' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('taxes_payment_tax_value_col', inv.id, '_tax_value_taxes')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_value_taxes' + inv.id]),
        expression: "editable['edit_tax_value_taxes' + inv.id]"
      }]
    }, [_c('input', {
      ref: "taxes_payment_tax_value_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('taxes_payment_tax_value_col', $event, inv.id, '_tax_value_taxes')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type === 'hostFee') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_value_host_fee' + inv.id]),
        expression: "!editable['edit_tax_value_host_fee' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('host_fee_payment_tax_value_col', inv.id, '_tax_value_host_fee')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_value_host_fee' + inv.id]),
        expression: "editable['edit_tax_value_host_fee' + inv.id]"
      }]
    }, [_c('input', {
      ref: "host_fee_payment_tax_value_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('host_fee_payment_tax_value_col', $event, inv.id, '_tax_value_host_fee')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type === 'promotion') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_value_promotion' + inv.id]),
        expression: "!editable['edit_tax_value_promotion' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('promotion_payment_tax_value_col', inv.id, '_tax_value_promotion')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')) + "\n                                              ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_value_promotion' + inv.id]),
        expression: "editable['edit_tax_value_promotion' + inv.id]"
      }]
    }, [_c('input', {
      ref: "promotion_payment_tax_value_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('promotion_payment_tax_value_col', $event, inv.id, '_tax_value_promotion')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'nights') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_value_nights' + inv.id]),
        expression: "!editable['edit_tax_value_nights' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('nights_payment_tax_value_col', inv.id, '_tax_value_nights')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_value_nights' + inv.id]),
        expression: "editable['edit_tax_value_nights' + inv.id]"
      }]
    }, [_c('input', {
      ref: "nights_payment_tax_value_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('nights_payment_tax_value_col', $event, inv.id, '_tax_value_nights')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type === 'schedule') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_value_schedule' + inv.id]),
        expression: "!editable['edit_tax_value_schedule' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('schedule_payment_tax_value_col', inv.id, '_tax_value_schedule')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_value_schedule' + inv.id]),
        expression: "editable['edit_tax_value_schedule' + inv.id]"
      }]
    }, [_c('input', {
      ref: "schedule_payment_tax_value_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('schedule_payment_tax_value_col', $event, inv.id, '_tax_value_schedule')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type === 'auto') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_tax_value_auto' + inv.id]),
        expression: "!editable['edit_tax_value_auto' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('auto_payment_tax_value_col', inv.id, '_tax_value_auto')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_tax_value_auto' + inv.id]),
        expression: "editable['edit_tax_value_auto' + inv.id]"
      }]
    }, [_c('input', {
      ref: "auto_payment_tax_value_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].tax_value ? _vm.obj[0].tax_value : (inv.vatAmount ? inv.vatAmount : '0')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('auto_payment_tax_value_col', $event, inv.id, '_tax_value_auto')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (!['other', 'service charge', 'cleaning', 'taxes', 'nights', 'schedule', 'auto', 'hostFee', 'promotion'].includes(inv.type)) ? _c('span', [_vm._v("\n                                              0,00\n                                            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text_right no_wrap number total_price_gross_col",
      staticStyle: {
        "-webkit-box-sizing": "border-box",
        "-moz-box-sizing": "border-box",
        "box-sizing": "border-box",
        "text-shadow": "none !important",
        "color": "#000 !important",
        "background-color": "transparent !important",
        "box-shadow": "none !important",
        "white-space": "nowrap !important",
        "text-align": "right",
        "page-break-inside": "avoid !important",
        "page-break-after": "auto",
        "vertical-align": "top",
        "border-collapse": "collapse",
        "margin": "0",
        "padding": "5px",
        "border": "1px solid #d8d7d7"
      },
      attrs: {
        "align": "right",
        "bgcolor": "transparent !important",
        "valign": "top"
      }
    }, [(inv.type == 'other') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_gross_other' + inv.id]),
        expression: "!editable['edit_gross_other' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('other_payment_total_gross_col', inv.id, '_gross_other')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_gross_other' + inv.id]),
        expression: "editable['edit_gross_other' + inv.id]"
      }]
    }, [_c('input', {
      ref: "other_payment_total_gross_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('other_payment_total_gross_col', $event, inv.id, '_gross_other')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'service charge') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_gross_service_charge' + inv.id]),
        expression: "!editable['edit_gross_service_charge' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('service_charge_payment_total_gross_col', inv.id, '_gross_service_charge')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_gross_service_charge' + inv.id]),
        expression: "editable['edit_gross_service_charge' + inv.id]"
      }]
    }, [_c('input', {
      ref: "service_charge_payment_total_gross_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('service_charge_payment_total_gross_col', $event, inv.id, '_gross_service_charge')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'cleaning') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_gross_cleaning' + inv.id]),
        expression: "!editable['edit_gross_cleaning' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('cleaning_payment_total_gross_col', inv.id, '_gross_cleaning')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_gross_cleaning' + inv.id]),
        expression: "editable['edit_gross_cleaning' + inv.id]"
      }]
    }, [_c('input', {
      ref: "cleaning_payment_total_gross_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('cleaning_payment_total_gross_col', $event, inv.id, '_gross_cleaning')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'taxes') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_gross_taxes' + inv.id]),
        expression: "!editable['edit_gross_taxes' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('taxes_payment_total_gross_col', inv.id, '_gross_taxes')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_gross_taxes' + inv.id]),
        expression: "editable['edit_gross_taxes' + inv.id]"
      }]
    }, [_c('input', {
      ref: "taxes_payment_total_gross_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('taxes_payment_total_gross_col', $event, inv.id, '_gross_taxes')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'hostFee') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_gross_host_fee' + inv.id]),
        expression: "!editable['edit_gross_host_fee' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('host_fee_payment_total_gross_col', inv.id, '_gross_host_fee')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_gross_host_fee' + inv.id]),
        expression: "editable['edit_gross_host_fee' + inv.id]"
      }]
    }, [_c('input', {
      ref: "host_fee_payment_total_gross_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('host_fee_payment_total_gross_col', $event, inv.id, '_gross_host_fee')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'promotion') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_gross_promotion' + inv.id]),
        expression: "!editable['edit_gross_promotion' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('promotion_payment_total_gross_col', inv.id, '_gross_promotion')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_gross_promotion' + inv.id]),
        expression: "editable['edit_gross_promotion' + inv.id]"
      }]
    }, [_c('input', {
      ref: "promotion_payment_total_gross_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('promotion_payment_total_gross_col', $event, inv.id, '_gross_promotion')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type == 'nights') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_gross_nights' + inv.id]),
        expression: "!editable['edit_gross_nights' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('nights_payment_total_gross_col', inv.id, '_gross_nights')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_gross_nights' + inv.id]),
        expression: "editable['edit_gross_nights' + inv.id]"
      }]
    }, [_c('input', {
      ref: "nights_payment_total_gross_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('nights_payment_total_gross_col', $event, inv.id, '_gross_nights')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type === 'schedule') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_gross_schedule' + inv.id]),
        expression: "!editable['edit_gross_schedule' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('schedule_payment_total_gross_col', inv.id, '_gross_schedule')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_gross_schedule' + inv.id]),
        expression: "editable['edit_gross_schedule' + inv.id]"
      }]
    }, [_c('input', {
      ref: "schedule_payment_total_gross_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('schedule_payment_total_gross_col', $event, inv.id, '_gross_schedule')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (inv.type === 'auto') ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable['edit_gross_auto' + inv.id]),
        expression: "!editable['edit_gross_auto' + inv.id]"
      }],
      on: {
        "click": function($event) {
          _vm.enableEditing('auto_payment_total_gross_col', inv.id, '_gross_auto')
        }
      }
    }, [_c('div', {
      attrs: {
        "aaa": _vm.obj = _vm.fictivePayments.filter(function (obj) { return obj.payment_id == inv.id; })
      }
    }), _vm._v("\n                                                " + _vm._s(_vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable['edit_gross_auto' + inv.id]),
        expression: "editable['edit_gross_auto' + inv.id]"
      }]
    }, [_c('input', {
      ref: "auto_payment_total_gross_col",
      refInFor: true,
      attrs: {
        "id": 'input_id_' + inv.id
      },
      domProps: {
        "value": _vm.obj.length != 0 && _vm.obj[0].gross ? _vm.obj[0].gross : (inv.amount ? inv.amount * inv.quantity : '-')
      },
      on: {
        "blur": function($event) {
          _vm.autoSave('auto_payment_total_gross_col', $event, inv.id, '_gross_auto')
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (!['other', 'service charge', 'cleaning', 'taxes', 'nights', 'schedule', 'auto', 'hostFee', 'promotion'].includes(inv.type)) ? _c('span', [_vm._v("\n                                              " + _vm._s(inv.amount) + "\n                                            ")]) : _vm._e(), _vm._v("\n                                            " + _vm._s(_vm.rental.currency))])]) : _vm._e()
  })), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }, [_c('tr', {
    staticClass: "clean no_border summary_row",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('td', {
    staticClass: "empty nr_col footer total",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "text-align": "right",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "margin": "0",
      "padding": "5px",
      "border": "0 solid #d8d7d7"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "empty price_net_col price_gross_col price_gross_col-hide_tax footer total",
    staticStyle: {
      "display": "none",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "float": "none",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "text-align": "right",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "margin": "0",
      "padding": "5px",
      "border": "0 solid #d8d7d7"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text_right no_border total footer total",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "right",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "margin": "0",
      "padding": "5px",
      "border": "0 solid #d8d7d7"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-weight": "bold",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.total_label),
      expression: "!editable.total_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('total_label')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.total_label ? _vm.invoice.total_label : 'Total: ')) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.total_label),
      expression: "editable.total_label"
    }]
  }, [_c('input', {
    ref: "total_label",
    domProps: {
      "value": (_vm.invoice.total_label ? _vm.invoice.total_label : 'Total: ')
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('total_label', $event)
      }
    }
  })])])]), _vm._v(" "), _c('td', {
    staticClass: "text_right number total_price_net_col footer total",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "white-space": "nowrap !important",
      "text-align": "right",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "margin": "0",
      "padding": "5px",
      "border": "0 solid #d8d7d7"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.invoiceSum),
      expression: "!editable.invoiceSum"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('invoiceSum')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.invoiceSum ? _vm.invoice.invoiceSum : (_vm.invoiceSum ? _vm.invoiceSum : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.invoiceSum),
      expression: "editable.invoiceSum"
    }]
  }, [_c('input', {
    ref: "invoiceSum",
    domProps: {
      "value": (_vm.invoice.invoiceSum ? _vm.invoice.invoiceSum : (_vm.invoiceSum ? _vm.invoiceSum : '-'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('invoiceSum', $event)
      }
    }
  })]), _vm._v("\n                                        " + _vm._s(_vm.rental.currency) + "\n                                      ")]), _vm._v(" "), _c('td', {
    staticClass: "tax_col footer total",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "text-align": "right",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "margin": "0",
      "padding": "5px",
      "border": "0 solid #d8d7d7"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text_right number tax_value_col footer total",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "white-space": "nowrap !important",
      "text-align": "right",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "margin": "0",
      "padding": "5px",
      "border": "0 solid #d8d7d7"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.invoiceSum_tva),
      expression: "!editable.invoiceSum_tva"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('invoiceSum_tva')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.invoiceSum_tva ? _vm.invoice.invoiceSum_tva : (_vm.vatSum ? _vm.vatSum : '0.00'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.invoiceSum_tva),
      expression: "editable.invoiceSum_tva"
    }]
  }, [_c('input', {
    ref: "invoiceSum_tva",
    domProps: {
      "value": (_vm.invoice.invoiceSum_tva ? _vm.invoice.invoiceSum_tva : (_vm.vatSum ? _vm.vatSum : '0.00'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('invoiceSum_tva', $event)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "width3 text_right number total_price_gross_col footer total",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "white-space": "nowrap !important",
      "text-align": "right",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "width": "7%",
      "vertical-align": "top",
      "border-collapse": "collapse",
      "margin": "0",
      "padding": "5px",
      "border": "0 solid #d8d7d7"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.invoiceSum2),
      expression: "!editable.invoiceSum2"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('invoiceSum2')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.invoiceSum2 ? (parseFloat(_vm.invoice.invoiceSum2).toFixed(2)) : (_vm.invoiceSum2 ? _vm.invoiceSum2 : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.invoiceSum2),
      expression: "editable.invoiceSum2"
    }]
  }, [_c('input', {
    ref: "invoiceSum2",
    domProps: {
      "value": (_vm.invoice.invoiceSum2 ? _vm.invoice.invoiceSum2 : (_vm.invoiceSum2 ? _vm.invoiceSum2 : '-'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('invoiceSum2', $event)
      }
    }
  })]), _vm._v("\n                                        " + _vm._s(_vm.rental.currency) + "\n                                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "clear": "both",
      "float": "none",
      "height": "1px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "clean to_right totals_inv_table",
    staticStyle: {
      "page-break-inside": "avoid !important",
      "border-collapse": "collapse",
      "border-spacing": "0",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "max-width": "100%",
      "font-size": "0.6em",
      "page-break-after": "auto",
      "clear": "both",
      "empty-cells": "hide",
      "width": "99%",
      "text-align": "left",
      "vertical-align": "top",
      "float": "right",
      "line-height": "1em",
      "margin": "0px auto 5px",
      "border": "0"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('th', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "right",
      "vertical-align": "top",
      "font-weight": "bold",
      "margin": "0",
      "padding": "5px 4px 5px 5px",
      "border": "0"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.total_ht_label),
      expression: "!editable.total_ht_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('total_ht_label')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.total_ht_label ? _vm.invoice.total_ht_label : _vm.$t('booking.detail.invoices.total_ht'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.total_ht_label),
      expression: "editable.total_ht_label"
    }]
  }, [_c('input', {
    ref: "total_ht_label",
    domProps: {
      "value": (_vm.invoice.total_ht_label ? _vm.invoice.total_ht_label : _vm.$t('booking.detail.invoices.total_ht'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('total_ht_label', $event)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "number",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "white-space": "nowrap !important",
      "text-align": "right",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top",
      "width": "15%",
      "margin": "0",
      "padding": "5px 4px 5px 10px",
      "border": "0"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.total_ht_invoice_sum),
      expression: "!editable.total_ht_invoice_sum"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('total_ht_invoice_sum')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.total_ht_invoice_sum ? _vm.invoice.total_ht_invoice_sum : (_vm.invoiceSum ? _vm.invoiceSum : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.total_ht_invoice_sum),
      expression: "editable.total_ht_invoice_sum"
    }]
  }, [_c('input', {
    ref: "total_ht_invoice_sum",
    domProps: {
      "value": (_vm.invoice.total_ht_invoice_sum ? _vm.invoice.total_ht_invoice_sum : (_vm.invoiceSum ? _vm.invoiceSum : '-'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('total_ht_invoice_sum', $event)
      }
    }
  })]), _vm._v("\n                                          " + _vm._s(_vm.rental.currency) + "\n                                        ")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('th', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "right",
      "vertical-align": "top",
      "font-weight": "bold",
      "margin": "0",
      "padding": "5px 4px 5px 5px",
      "border": "0"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.reduction_label),
      expression: "!editable.reduction_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('reduction_label')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.reduction_label ? _vm.invoice.reduction_label : _vm.$t('booking.detail.invoices.reduction'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.reduction_label),
      expression: "editable.reduction_label"
    }]
  }, [_c('input', {
    ref: "reduction_label",
    domProps: {
      "value": (_vm.invoice.reduction_label ? _vm.invoice.reduction_label : _vm.$t('booking.detail.invoices.reduction'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('reduction_label', $event)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "number",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "white-space": "nowrap !important",
      "text-align": "right",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top",
      "width": "15%",
      "margin": "0",
      "padding": "5px 4px 5px 10px",
      "border": "0"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.reduction_value),
      expression: "!editable.reduction_value"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('reduction_value')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.reduction_value ? _vm.invoice.reduction_value : '0,00')) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.reduction_value),
      expression: "editable.reduction_value"
    }]
  }, [_c('input', {
    ref: "reduction_value",
    domProps: {
      "value": (_vm.invoice.reduction_value ? _vm.invoice.reduction_value : '0,00')
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('reduction_value', $event)
      }
    }
  })])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('th', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "right",
      "vertical-align": "top",
      "font-weight": "bold",
      "margin": "0",
      "padding": "5px 4px 5px 5px",
      "border": "0"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.total_ht_discount_label),
      expression: "!editable.total_ht_discount_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('total_ht_discount_label')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.total_ht_discount_label ? _vm.invoice.total_ht_discount_label : _vm.$t('booking.detail.invoices.total_discounted'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.total_ht_discount_label),
      expression: "editable.total_ht_discount_label"
    }]
  }, [_c('input', {
    ref: "total_ht_discount_label",
    domProps: {
      "value": (_vm.invoice.total_ht_discount_label ? _vm.invoice.total_ht_discount_label : _vm.$t('booking.detail.invoices.total_discounted'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('total_ht_discount_label', $event)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "number",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "white-space": "nowrap !important",
      "text-align": "right",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top",
      "width": "15%",
      "margin": "0",
      "padding": "5px 4px 5px 10px",
      "border": "0"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.total_ht_discount_value),
      expression: "!editable.total_ht_discount_value"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('total_ht_discount_value')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.total_ht_discount_value ? _vm.invoice.total_ht_discount_value : (_vm.invoiceSum ? _vm.invoiceSum : '-'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.total_ht_discount_value),
      expression: "editable.total_ht_discount_value"
    }]
  }, [_c('input', {
    ref: "total_ht_discount_value",
    domProps: {
      "value": (_vm.invoice.total_ht_discount_value ? _vm.invoice.total_ht_discount_value : (_vm.invoiceSum ? _vm.invoiceSum : '-'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('total_ht_discount_value', $event)
      }
    }
  })]), _vm._v("\n                                          " + _vm._s(_vm.rental.currency) + "\n                                        ")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('th', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "right",
      "vertical-align": "top",
      "font-weight": "bold",
      "margin": "0",
      "padding": "5px 4px 5px 5px",
      "border": "0"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.vat_amount_label),
      expression: "!editable.vat_amount_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('vat_amount_label')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.vat_amount_label ? _vm.invoice.vat_amount_label : _vm.$t('booking.detail.invoices.vat_amount'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.vat_amount_label),
      expression: "editable.vat_amount_label"
    }]
  }, [_c('input', {
    ref: "vat_amount_label",
    domProps: {
      "value": (_vm.invoice.vat_amount_label ? _vm.invoice.vat_amount_label : _vm.$t('booking.detail.invoices.vat_amount'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('vat_amount_label', $event)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "number",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "white-space": "nowrap !important",
      "text-align": "right",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top",
      "width": "15%",
      "margin": "0",
      "padding": "5px 4px 5px 10px",
      "border": "0"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.vat_amount_value),
      expression: "!editable.vat_amount_value"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('vat_amount_value')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.vat ? _vm.invoice.vat : (_vm.vatSum ? _vm.vatSum : '0.00'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.vat_amount_value),
      expression: "editable.vat_amount_value"
    }]
  }, [_c('input', {
    ref: "vat_amount_value",
    domProps: {
      "value": (_vm.invoice.vat ? _vm.invoice.vat : (_vm.vatSum ? _vm.vatSum : '0.00'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('vat_amount_value', $event)
      }
    }
  })])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('th', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "right",
      "vertical-align": "top",
      "font-weight": "bold",
      "margin": "0",
      "padding": "5px 4px 5px 5px",
      "border": "0"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.total_price_label),
      expression: "!editable.total_price_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('total_price_label')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.total_price_label ? _vm.invoice.total_price_label : _vm.$t('booking.detail.invoices.total_ttc'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.total_price_label),
      expression: "editable.total_price_label"
    }]
  }, [_c('input', {
    ref: "total_price_label",
    domProps: {
      "value": (_vm.invoice.total_price_label ? _vm.invoice.total_price_label : _vm.$t('booking.detail.invoices.total_ttc'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('total_price_label', $event)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "number",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "white-space": "nowrap !important",
      "text-align": "right",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top",
      "width": "15%",
      "margin": "0",
      "padding": "5px 4px 5px 10px",
      "border": "0"
    },
    attrs: {
      "align": "right",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.total_price_value),
      expression: "!editable.total_price_value"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('total_price_value')
      }
    }
  }, [_vm._v("  " + _vm._s((_vm.invoice.total_price_value ? _vm.invoice.total_price_value : (_vm.invoiceSum2 ? _vm.invoiceSum2 : '0,00'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.total_price_value),
      expression: "editable.total_price_value"
    }]
  }, [_c('input', {
    ref: "total_price_value",
    domProps: {
      "value": (_vm.invoice.total_price_value ? _vm.invoice.total_price_value : (_vm.invoiceSum2 ? _vm.invoiceSum2 : '0,00'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('total_price_value', $event)
      }
    }
  })]), _vm._v("\n                                          " + _vm._s(_vm.rental.currency) + "\n                                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "clear": "both",
      "float": "none",
      "height": "1px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "full_width",
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "max-width": "100%",
      "font-size": "0.6em",
      "page-break-after": "auto",
      "clear": "both",
      "empty-cells": "hide",
      "width": "99%",
      "text-align": "left",
      "vertical-align": "top",
      "page-break-inside": "auto",
      "margin": "0px auto",
      "border": "0"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('td', {
    staticClass: "empty",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "text-align": "left",
      "vertical-align": "top",
      "margin": "0",
      "padding": "5px",
      "border": "0"
    },
    attrs: {
      "align": "left",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-weight": "bold",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.reserved_on_label_first),
      expression: "!editable.reserved_on_label_first"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('reserved_on_label_first')
      }
    }
  }, [_vm._v(_vm._s(_vm.invoice.reserved_on_label_first ? _vm.invoice.reserved_on_label_first : _vm.$t('booking.detail.invoices.reserved_on_label_first')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.reserved_on_label_first),
      expression: "editable.reserved_on_label_first"
    }]
  }, [_c('input', {
    ref: "reserved_on_label_first",
    domProps: {
      "value": _vm.invoice.reserved_on_label_first ? _vm.invoice.reserved_on_label_first : _vm.$t('booking.detail.invoices.reserved_on_label_first')
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('reserved_on_label_first', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.booking_date),
      expression: "!editable.booking_date"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('booking_date')
      }
    }
  }, [_vm._v(_vm._s(_vm.invoice.booking_date ? _vm.invoice.booking_date : _vm.booking.booking_date))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.booking_date),
      expression: "editable.booking_date"
    }]
  }, [_c('input', {
    ref: "booking_date",
    domProps: {
      "value": (_vm.invoice.booking_date ? _vm.invoice.booking_date : _vm.booking.booking_date)
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('booking_date', $event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.reserved_on_label_second),
      expression: "!editable.reserved_on_label_second"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('reserved_on_label_second')
      }
    }
  }, [_vm._v(_vm._s(_vm.invoice.reserved_on_label_second ? _vm.invoice.reserved_on_label_second : _vm.$t('booking.detail.invoices.reserved_on_label_second')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.reserved_on_label_second),
      expression: "editable.reserved_on_label_second"
    }]
  }, [_c('input', {
    ref: "reserved_on_label_second",
    domProps: {
      "value": (_vm.invoice.reserved_on_label_second ? _vm.invoice.reserved_on_label_second : _vm.$t('booking.detail.invoices.reserved_on_label_second'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('reserved_on_label_second', $event)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.reserved_on),
      expression: "!editable.reserved_on"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('reserved_on')
      }
    }
  }, [_vm._v(" " + _vm._s((_vm.invoice.reserved_on ? _vm.invoice.reserved_on : 'Direct')) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.reserved_on),
      expression: "editable.reserved_on"
    }]
  }, [_c('input', {
    ref: "reserved_on",
    domProps: {
      "value": (_vm.invoice.reserved_on ? _vm.invoice.reserved_on : 'Direct')
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('reserved_on', $event)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-inside": "avoid !important",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }, [_c('table', {
    staticClass: "full_width",
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "max-width": "100%",
      "font-size": "0.6em",
      "page-break-after": "auto",
      "clear": "both",
      "empty-cells": "hide",
      "width": "99%",
      "text-align": "left",
      "vertical-align": "top",
      "page-break-inside": "auto",
      "margin": "0px auto",
      "border": "0"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('td', {
    staticClass: "empty",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "text-align": "left",
      "vertical-align": "top",
      "margin": "0",
      "padding": "5px",
      "border": "0"
    },
    attrs: {
      "align": "left",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    },
    attrs: {
      "id": "type_of_payment_field"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-weight": "bold",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.payment_choice_label),
      expression: "!editable.payment_choice_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('payment_choice_label')
      }
    }
  }, [_vm._v(_vm._s((_vm.invoice.payment_choice_label ? _vm.invoice.payment_choice_label : _vm.$t('booking.detail.invoices.payment_choice'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.payment_choice_label),
      expression: "editable.payment_choice_label"
    }]
  }, [_c('input', {
    ref: "payment_choice_label",
    domProps: {
      "value": (_vm.invoice.payment_choice_label ? _vm.invoice.payment_choice_label : _vm.$t('booking.detail.invoices.payment_choice'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('payment_choice_label', $event)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.bank_card_label),
      expression: "!editable.bank_card_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('bank_card_label')
      }
    }
  }, [_vm._v(_vm._s((_vm.invoice.bank_card_label ? _vm.invoice.bank_card_label : _vm.$t('booking.detail.invoices.bank_card'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.bank_card_label),
      expression: "editable.bank_card_label"
    }]
  }, [_c('input', {
    ref: "bank_card_label",
    domProps: {
      "value": (_vm.invoice.bank_card_label ? _vm.invoice.bank_card_label : _vm.$t('booking.detail.invoices.bank_card'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('bank_card_label', $event)
      }
    }
  })]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  })])])])])]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('section', {
    staticStyle: {
      "display": "block",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "vertical-align": "bottom",
      "width": "100%",
      "margin": "30px 0 0",
      "padding": "15px 22% 0",
      "border": "0"
    },
    attrs: {
      "id": "description_footer"
    }
  }, [_c('div', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "height": "auto",
      "max-height": "50px",
      "padding-top": "0px"
    },
    attrs: {
      "id": "company_info_footer"
    }
  }, [_c('span', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "margin-left": "auto",
      "margin-right": "auto",
      "max-width": "407px",
      "display": "block",
      "overflow": "hidden",
      "line-height": "11.3px !important",
      "font-family": "arial,sans-serif,tahoma !important",
      "font-size": "9.85px !important",
      "letter-spacing": "normal !important",
      "text-align": "center",
      "height": "50px !important",
      "max-height": "50px",
      "padding-top": "0px"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.footer_label),
      expression: "!editable.footer_label"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('footer_label')
      }
    }
  }, [_vm._v("\n                                    " + _vm._s((_vm.invoice.footer_label ? _vm.invoice.footer_label :
    ((_vm.rental.invoice_name ? _vm.rental.invoice_name + ' - ' : '') +
      (_vm.rental.invoice_address ? _vm.rental.invoice_address + ', ' : '') +
      (_vm.rental.invoice_zip_code ? _vm.rental.invoice_zip_code + ', ' : '') +
      (_vm.rental.invoice_city ? _vm.rental.invoice_city + ', ' : '') +
      (_vm.rental.invoice_country ? _vm.rental.invoice_country : '')))) + "\n                                    "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.invoice.footer_label && !_vm.rental.invoice_name && !_vm.rental.invoice_address && !_vm.rental.invoice_city && !_vm.rental.invoice_country),
      expression: "!invoice.footer_label && !rental.invoice_name && !rental.invoice_address && !rental.invoice_city && !rental.invoice_country "
    }]
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.footer_label),
      expression: "editable.footer_label"
    }]
  }, [_c('input', {
    ref: "footer_label",
    domProps: {
      "value": (_vm.invoice.footer_label ? _vm.invoice.footer_label : (
        (_vm.rental.invoice_name ? _vm.rental.invoice_name + ' - ' : '') +
        (_vm.rental.invoice_address ? _vm.rental.invoice_address + ', ' : '') +
        (_vm.rental.invoice_zip_code ? _vm.rental.invoice_zip_code + ', ' : '') +
        (_vm.rental.invoice_city ? _vm.rental.invoice_city + ', ' : '') +
        (_vm.rental.invoice_country ? _vm.rental.invoice_country : '')))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('footer_label', $event)
      }
    }
  })]), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "editable",
    attrs: {
      "data-url": "http://app.superhote.com/pages/index.php?/bookings/get_text"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.footer_bottom_text),
      expression: "!editable.footer_bottom_text"
    }],
    on: {
      "click": function($event) {
        _vm.enableEditing('footer_bottom_text')
      }
    }
  }, [_vm._v(_vm._s((_vm.invoice.footer_bottom_text ? _vm.invoice.footer_bottom_text : _vm.rental.invoice_footer ? _vm.rental.invoice_footer : _vm.$t('booking.detail.invoices.footer_bottom_text'))) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.footer_bottom_text),
      expression: "editable.footer_bottom_text"
    }]
  }, [_c('input', {
    ref: "footer_bottom_text",
    domProps: {
      "value": (_vm.invoice.footer_bottom_text ? _vm.invoice.footer_bottom_text : _vm.rental.invoice_footer ? _vm.rental.invoice_footer : _vm.$t('booking.detail.invoices.vat_not_applicable'))
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('footer_bottom_text', $event)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditable),
      expression: "isEditable"
    }],
    staticClass: "contract-preview",
    attrs: {
      "data-html2canvas-ignore": ""
    }
  }, [_c('button', {
    staticClass: "form-submit-button",
    attrs: {
      "type": "button",
      "data-html2canvas-ignore": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetInvoice()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.reset")))]), _vm._v(" "), _c('button', {
    staticClass: "form-submit-button",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "button",
      "data-html2canvas-ignore": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createPDF()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.download")))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditable),
      expression: "!isEditable"
    }],
    attrs: {
      "data-html2canvas-ignore": ""
    }
  }, [_c('div', {
    staticClass: "contract-preview",
    attrs: {
      "id": "download-pdf"
    }
  }, [_c('button', {
    staticClass: "form-submit-button",
    attrs: {
      "type": "button",
      "data-html2canvas-ignore": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createPDF()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.download")))])])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "role": "menuitem"
    }
  }, [_c('span', {
    staticClass: "flag-icon flag-icon-us"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "role": "menuitem"
    }
  }, [_c('span', {
    staticClass: "flag-icon flag-icon-fr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no_print text-center",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "text-align": "center",
      "display": "none !important"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "orphans": "3",
      "widows": "3",
      "line-height": "1.4em",
      "margin": "0 0 0.5em"
    }
  }, [_c('strong', {
    staticClass: "medium_text",
    staticStyle: {
      "font-weight": "bold",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "display": "block",
      "margin-top": "0px !important",
      "margin-bottom": "7px !important"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "full_width",
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0",
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "max-width": "100%",
      "font-size": "0.6em",
      "page-break-after": "auto",
      "clear": "both",
      "empty-cells": "hide",
      "width": "99%",
      "text-align": "left",
      "vertical-align": "top",
      "page-break-inside": "auto",
      "margin": "0px auto",
      "border": "0"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "vertical-align": "top"
    },
    attrs: {
      "bgcolor": "transparent !important"
    }
  }, [_c('td', {
    staticClass: "text_center half_width",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "text-align": "center",
      "vertical-align": "top",
      "width": "50%",
      "margin": "0",
      "padding": "5px",
      "border": "0"
    },
    attrs: {
      "align": "center",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text_center half_width",
    staticStyle: {
      "-webkit-box-sizing": "border-box",
      "-moz-box-sizing": "border-box",
      "box-sizing": "border-box",
      "text-shadow": "none !important",
      "color": "#000 !important",
      "background-color": "transparent !important",
      "box-shadow": "none !important",
      "page-break-inside": "avoid !important",
      "page-break-after": "auto",
      "text-align": "center",
      "vertical-align": "top",
      "width": "50%",
      "margin": "0",
      "padding": "5px",
      "border": "0"
    },
    attrs: {
      "align": "center",
      "bgcolor": "transparent !important",
      "valign": "top"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3570a573"}!./src/app/pages/bookings/invoice/invoice.html
// module id = 1359
// module chunks = 0